import {AbstractControl} from '@angular/forms';

export function NoWhitespaceValidator(control: AbstractControl) {
  const isWhitespaceInValue = (control.value || '').trim().length === 0;
  return isWhitespaceInValue ? {whitespace: true} : null;
}

export function urlValidator(control: AbstractControl): {[key: string]: boolean} | null {
  const value = control.value.trim();
  const passed = validateUrl(value);
  if (!passed) {
    return {url: true};
  }

  return null;
}

export function validateUrl(host: string) {
  const hostWithoutWww = host.replace(URL_WWW_REGEX, '');

  let regexp = URL_MAIN_REGEX;
  if (hostWithoutWww.startsWith('http')) {
    regexp = URL_MAIN_WITH_PROTOCOL_REGEX;
  }
  if (host.toLowerCase().startsWith('localhost')) {
    regexp = URL_LOCALHOST_REGEX;
  }
  return (
    (regexp.test(hostWithoutWww) && !URL_FORBIDDEN_REGEX.test(hostWithoutWww)) || ipv4AddressRegex.test(hostWithoutWww)
  );
}

export const A11Y_LINK_TEXT_REGEX = /^(\s+\S+\s*)*(?!\s).*$/;

export const URL_MAIN_REGEX = new RegExp(
  /^((?![-_~.:/?#\[\]@!$&'()*+,;=%])[a-zA-Z\d-]{1,}(\.){1})+([a-zA-Z]{2,}\/?)([a-zA-Z\d-._~:/?#\[\]@!$&'()*+,;=]*)$/i,
);
export const URL_MAIN_WITH_PROTOCOL_REGEX = new RegExp(
  /(^https?:\/\/)((?![-_~.:/?#\[\]@!$&'()*+,;=%])[a-zA-Z\d-]{1,}(\.){1})+([a-zA-Z]{2,}\/?)([a-zA-Z\d-._~:/?#\[\]@!$&'()*+,;=]*)$/i,
);
export const URL_WWW_REGEX = new RegExp(/(www.)/);
export const URL_PROTOCOL_REGEX = new RegExp(/(^https?:\/\/)/);

export const URL_LOCALHOST_REGEX = new RegExp(/(localhost:|localhost)/);

export const URL_FORBIDDEN_REGEX = new RegExp(/([\s[\]{},!@#$%№;?^&*()+=|\\^]+)/i);

export const ipv4AddressRegex =
  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

export const EMAIL_REGEXP =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const IP_WHITELIST_REGEXP = /[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}/g;

export const IP_V6_WHITELIST_REGEXP = /^([\da-f]{1,4}:){7}[\da-f]{1,4}$/i;

export const FULLNAME_REGEX = /^[A-Za-z]+(?:[-' ][A-Za-z]+)*$/;

export const PHONE_REGEX = /^\+?([0-9]{9,13})$/;

export const COLOR_FROM_GRADIENT_REGEX = /(?:#)[0-9a-f]{8}|(?:#)[0-9a-f]{6}|(?:#)[0-9a-f]{4}|(?:#)[0-9a-f]{3}/gi;
export const HEX_COLOR_REGEX = /^#(?:[0-9a-fA-F]{6}){1,2}$/;

export const NON_NUMERIC_CHARACTERS_REG_EXP = /[^\d+]/g;
